import { getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  appReleasesList: [],
  prevPage: -1,
  nextPage: -1,
  activeFilters: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_FLEET_COACH_APP_RELEASES_LIST:
      return setFleetCoachAppReleasesList(state, action);
    case ActionTypes.SET_FLEET_COACH_APP_RELEASES_ACTIVE_FILTERS:
      return setFleetCoachAppReleasesActiveFilters(state, action);
    default:
      return state;
  }
}

const setFleetCoachAppReleasesList = (state, action) => {
  return {
    ...state,
    appReleasesList: getPath(action.payload, "data", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};

const setFleetCoachAppReleasesActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
